import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatPostGuestLogin} from './NatPostGuestLogin'
import {NatPostGuestLogout} from './NatPostGuestLogout'

export default class NatGuestLoginRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // ログイン認証
    async postLogin(accessKey: string): Promise<NatPostGuestLogin> {
        return await this.http.post(
            `/guest/login`,
            {accessKey: accessKey},
            ContentType.JSON
        )
    }

    // ログアウト
    async postLogout(): Promise<NatPostGuestLogout> {
        return await this.http.post(`/guest/logout`, {}, ContentType.JSON,
        )
    }
}
